
// Working before dynamic

// import React, { useState } from 'react';
// import '../styles/AddDepartment.css';

// const AddDepartment = () => {
//   const [formData, setFormData] = useState({
//     deptName: '',
//     deptShortName: '',
//     deptCode: ''
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // Progress logic consistent with AddEmployee
//   const calculateProgress = () => {
//     const filled = Object.values(formData).filter(v => v !== '').length;
//     return (filled / 3) * 100;
//   };

//   const handleAdd = async (e) => {
//     e.preventDefault();

//     const submitData = {
//       departmentName: formData.deptName,
//       departmentShortName: formData.deptShortName,
//       departmentCode: formData.deptCode
//     };

//     try {
//       const response = await fetch("/gt-api/add_department.php", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const result = await response.json();
//       if (result.success) {
//         alert(`SUCCESS: ${formData.deptName} initialized in core registry.`);
//         setFormData({ deptName: '', deptShortName: '', deptCode: '' });
//       } else {
//         alert("Error: " + result.message);
//       }
//     } catch (error) {
//       console.error("Connection Error:", error);
//       alert("System Offline: Could not reach the database node.");
//     }
//   };

//   return (
//     <div className="genesis-onboarding-hub animate-fade">
//       <div className="ambient-glow"></div>

//       <div className="hub-layout">
//         {/* LEFT PANEL: INPUT INTERFACE */}
//         <div className="interface-panel">
//           <div className="panel-header">
//             <div className="header-status-indicator">
//               <div className="pulse-dot"></div>
//               <span>Genesis Tech Engineers </span>
//             </div>
//             <h3 className="glitch-text" data-text="Department Onboarding">Department Onboarding</h3>
//           </div>

//           <form className="interactive-sequencer" onSubmit={handleAdd}>
//             <div className="sequencer-grid">
              
//               <div className="seq-group full">
//                 <label>DEPARTMENT_NAME</label>
//                 <input 
//                   type="text" 
//                   name="deptName"
//                   // placeholder="e.g. Technology Operations"
//                   value={formData.deptName} 
//                   onChange={handleChange} 
//                   required 
//                   autoComplete="off"
//                 />
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>SHORT_NAME</label>
//                   <input 
//                     type="text" 
//                     name="deptShortName"
//                     // placeholder="e.g. TECH-OPS"
//                     value={formData.deptShortName} 
//                     onChange={handleChange} 
//                     required 
//                     autoComplete="off"
//                   />
//                 </div>
//                 <div className="seq-group">
//                   <label>DEPARTMENT_CODE</label>
//                   <input 
//                     type="text" 
//                     name="deptCode"
//                     // placeholder="e.g. DEPT-101"
//                     value={formData.deptCode} 
//                     onChange={handleChange} 
//                     required 
//                     autoComplete="off"
//                   />
//                 </div>
//               </div>

//               <div className="seq-group full">
//                 <button type="submit" className="initialize-btn">
//                   ADD DEPARTMENT
//                   <div className="btn-glow"></div>
//                 </button>
//               </div>

//             </div>
//           </form>
//         </div>

//         {/* RIGHT PANEL: NEURAL PREVIEW */}
//         <div className="neural-preview-panel">
//           <div className="radial-status-container">
//             <svg className="radial-svg" viewBox="0 0 100 100">
//               <circle className="bg" cx="50" cy="50" r="45" />
//               <circle
//                 className="meter"
//                 cx="50" cy="50" r="45"
//                 style={{ strokeDashoffset: 282 - (282 * calculateProgress()) / 100 }}
//               />
//             </svg>
//             <div className="radial-info">
//               <span className="percent">{Math.round(calculateProgress())}%</span>
//               <span className="label">SYNCED</span>
//             </div>
//           </div>

//           <div className="glass-id-card">
//             <div className="card-glare"></div>
//             <div className="card-header">
//               <span className="genesis-chip"></span>
//               <span className="card-title">REGISTRY_NODE</span>
//             </div>
            
//             <div className="bio-avatar-wrapper">
//               <div className="bio-avatar">
//                 {formData.deptShortName.charAt(0) || 'D'}
//               </div>
//             </div>

//             <div className="bio-data">
//               <h4>{formData.deptName || 'NEW_DEPARTMENT'}</h4>
//               <p className="cyan-text">{formData.deptShortName || 'AWAITING_ID'}</p>
              
//               <div className="data-bits">
//                 <div className="bit"><span>CODE:</span> {formData.deptCode || '---'}</div>
//                 <div className="bit"><span>STATUS:</span> INITIALIZING</div>
//                 <div className="bit"><span>NODE:</span> GTE-DB-01</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddDepartment;














import React, { useState } from 'react';
import '../styles/AddDepartment.css';

const AddDepartment = () => {
  const [formData, setFormData] = useState({
    deptName: '',
    deptShortName: '',
    deptCode: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Progress logic consistent with AddEmployee
  const calculateProgress = () => {
    const filled = Object.values(formData).filter(v => v !== '').length;
    return (filled / 3) * 100;
  };

  const handleAdd = async (e) => {
    e.preventDefault();

    const submitData = {
      departmentName: formData.deptName,
      departmentShortName: formData.deptShortName,
      departmentCode: formData.deptCode
    };

    try {
     const response = await fetch("/gt-api/add_department.php", {
  method: "POST",
  credentials: "include",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(submitData),
});
      const result = await response.json();
      if (result.success) {
        alert(`SUCCESS: ${formData.deptName} initialized in core registry.`);
        setFormData({ deptName: '', deptShortName: '', deptCode: '' });
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Connection Error:", error);
      alert("System Offline: Could not reach the database node.");
    }
  };

  return (
    <div className="genesis-onboarding-hub animate-fade">
      <div className="ambient-glow"></div>

      <div className="hub-layout">
        {/* LEFT PANEL: INPUT INTERFACE */}
        <div className="interface-panel">
          <div className="panel-header">
            <div className="header-status-indicator">
              <div className="pulse-dot"></div>
              <span>Genesis Tech Engineers </span>
            </div>
            <h3 className="glitch-text" data-text="Department Onboarding">Department Onboarding</h3>
          </div>

          <form className="interactive-sequencer" onSubmit={handleAdd}>
            <div className="sequencer-grid">
              
              <div className="seq-group full">
                <label>DEPARTMENT_NAME</label>
                <input 
                  type="text" 
                  name="deptName"
                  // placeholder="e.g. Technology Operations"
                  value={formData.deptName} 
                  onChange={handleChange} 
                  required 
                  autoComplete="off"
                />
              </div>

              <div className="seq-row">
                <div className="seq-group">
                  <label>SHORT_NAME</label>
                  <input 
                    type="text" 
                    name="deptShortName"
                    // placeholder="e.g. TECH-OPS"
                    value={formData.deptShortName} 
                    onChange={handleChange} 
                    required 
                    autoComplete="off"
                  />
                </div>
                <div className="seq-group">
                  <label>DEPARTMENT_CODE</label>
                  <input 
                    type="text" 
                    name="deptCode"
                    // placeholder="e.g. DEPT-101"
                    value={formData.deptCode} 
                    onChange={handleChange} 
                    required 
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="seq-group full">
                <button type="submit" className="initialize-btn">
                  ADD DEPARTMENT
                  <div className="btn-glow"></div>
                </button>
              </div>

            </div>
          </form>
        </div>

        {/* RIGHT PANEL: NEURAL PREVIEW */}
        <div className="neural-preview-panel">
          <div className="radial-status-container">
            <svg className="radial-svg" viewBox="0 0 100 100">
              <circle className="bg" cx="50" cy="50" r="45" />
              <circle
                className="meter"
                cx="50" cy="50" r="45"
                style={{ strokeDashoffset: 282 - (282 * calculateProgress()) / 100 }}
              />
            </svg>
            <div className="radial-info">
              <span className="percent">{Math.round(calculateProgress())}%</span>
              <span className="label">SYNCED</span>
            </div>
          </div>

          <div className="glass-id-card">
            <div className="card-glare"></div>
            <div className="card-header">
              <span className="genesis-chip"></span>
              <span className="card-title">REGISTRY_NODE</span>
            </div>
            
            <div className="bio-avatar-wrapper">
              <div className="bio-avatar">
                {formData.deptShortName.charAt(0) || 'D'}
              </div>
            </div>

            <div className="bio-data">
              <h4>{formData.deptName || 'NEW_DEPARTMENT'}</h4>
              <p className="cyan-text">{formData.deptShortName || 'AWAITING_ID'}</p>
              
              <div className="data-bits">
                <div className="bit"><span>CODE:</span> {formData.deptCode || '---'}</div>
                <div className="bit"><span>STATUS:</span> INITIALIZING</div>
                <div className="bit"><span>NODE:</span> GTE-DB-01</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDepartment;